/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';

/* Services */

/**
 * Renders the MSR SectionTitle component.
 *
 * @param titleObj.titleObj
 * @param {object} titleObj component.
 * @param {object} rest some more data
 * @param titleObj.pageName
 * @returns {ReactElement} MSR SectionTitle component.
 */
const MsrSectionTitle = ({ titleObj, pageName, lang, maxwidth, ...rest }) => {
  const titleColor = {
    'no-decoration': '#FFA735',
    'drums-above': 'white.50',
    'white-drums-above': 'white.50',
    'white-no-decoration': '#FFF7E9',
    'black-drums-above': '#000000',
  };

  const textAlign = {
    'no-decoration': 'center',
    'drums-above': 'center',
    'white-drums-above': 'center',
    'white-no-decoration': 'left',
    'black-drums-above': 'center',
  };

  const maxW = {
    'no-decoration': { base: '100%', md: '515px' },
    'drums-above': { base: '100%', md: '515px', lg: '600px', xl: '770px' },
    'white-drums-above': { base: '100%', md: '515px', lg: '600px', xl: '770px' },
    'white-no-decoration': {
      xl: '1140px',
      lg: '754px',
      md: '754px',
      sm: '388px',
      base: '314px',
    },
    'black-drums-above': { base: '100%', md: '515px', lg: '600px', xl: '770px' },
  };

  const fontSize = {
    'no-decoration': { base: '24px', md: '48px' },
    'drums-above': { base: '24px', md: '40px' },
    'white-drums-above': { base: '24px', md: '40px' },
    'white-no-decoration': { base: '24px', md: '40px' },
    'black-drums-above': { base: '24px', md: '40px' },
  };

  const fontFamily = {
    'no-decoration': 'FedraSerifAStdBook',
    'drums-above': 'FedraSansStd-A-medium',
    'white-drums-above': 'FedraSansStd-A-medium',
    'white-no-decoration': 'FedraSansStd-A-medium',
    'black-drums-above': 'FedraSansStd-A-medium',
  };
  // const mx = {
  //   'no-decoration': 'auto',
  //   'drums-above': 'auto',
  //   'white-no-decoration': '0',
  // };

  return (
    <Box
      dir={lang == 'fa' ? 'rtl' : ''}
      maxW={maxwidth || rest.w || maxW[titleObj?.titleDecoration]}
      w={rest.w || '100%'}
      // mx={mx[titleObj?.titleDecoration]}
      mx="auto"
      fontFamily={
        lang == 'ta'
          ? 'MuktaMalar'
          : rest?.fontFamily || fontFamily[titleObj?.titleDecoration]
      }
      fontSize={{
        base:
          titleObj?.fontSize ||
          fontSize[titleObj?.titleDecoration]?.base ||
          (pageName === 'tamilthembu' && lang === 'ta' ? '24px' : '24px'),
        md:
          titleObj?.fontSize ||
          fontSize[titleObj?.titleDecoration]?.md ||
          (pageName === 'tamilthembu' && lang === 'ta' ? '40px' : '38px'),
      }}
      lineHeight="1.2"
      color={
        rest.color || titleObj?.color || titleColor[titleObj?.titleDecoration]
      }
      textAlign={textAlign[titleObj?.titleDecoration]}
      mt={{
        base: pageName == 'tamilthembu' ? '30px' : rest.mt ? rest.mt : '30px',
        md: pageName == 'tamilthembu' ? '90px' : rest.mt ? rest.mt : '30px',
      }}
      pt={{
        base: rest.pt || '0',
        md: rest.pt || '0',
      }}
      className="titleWrapper"
      fontWeight={
        rest?.fontWeight || (pageName === 'tamilthembu' && lang === 'ta')
          ? '600'
          : '500'
      }
    >
      {RenderBorder(titleObj?.titleDecoration) && (
        <Box textAlign="center" pb={'15px'}>
          {RenderBorder(titleObj?.titleDecoration)}
        </Box>
      )}

      <Box
        as={rest.as || 'h2'}
        m={{ base: '0 auto' }}
        mb={titleObj?.titleDecoration === 'white-no-decoration' ? '0' : '15px'}
        px={{ base: '10px', md: 0 }}
        maxW={maxwidth || rest.w || maxW[titleObj?.titleDecoration]}
      >
        {titleObj?.title || titleObj?.titleText}
        {titleObj?.titleSubtext && (
          <Box
            fontSize={{
              base:
                titleObj?.titleDecoration === 'no-decoration' ? '20px' : '16px',
              md:
                titleObj?.titleDecoration === 'no-decoration' ? '26px' : '16px',
            }}
            lineHeight="30px"
            textAlign="center"
            mt={titleObj?.titleDecoration === 'no-decoration' ? '6px' : '10px'}
            color={
              titleObj?.titleDecoration === 'no-decoration'
                ? '#FFFFFF'
                : '#FFA735'
            }
          >
            {titleObj?.titleSubtext}
          </Box>
        )}
      </Box>
    </Box>
  );
};

const RenderBorder = style => {
  style = style || 'default';
  const imgPath = {
    'no-decoration': '',
    'drums-above': '1664431985-drums-vector.png',
    'white-drums-above': '1746264339-msr_white_drum.png',
    'white-no-decoration': '',
    'black-drums-above': '1747199926-msr_black_drum.png',
  };

  return (
    imgPath[style] && (
      <LazyLoadImageComponent
        alt="divider"
        title="divider"
        minHeight="20px"
        src={
          imgPath[style]?.indexOf('https://') < 0
            ? `${config.staticPath}/d/46272/${imgPath[style]}`
            : imgPath[style]
        }
      />
    )
  );
};

export default MsrSectionTitle;
